import React from "react";
import { Link } from "react-router-dom";

interface ButtonProps {
  to?: string; // Optional, if not passed -> <button>
  children: React.ReactNode;
  layout?: "default" | "display-flex-center" | "display-flex-end" | "display-flex-start";
  color?: string;
  bgborder?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  scrollToTop?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  to,
  children,
  layout = "default",
  color = "#caa35c",
  bgborder = "#caa35c",
  onClick,
  scrollToTop = true,
}) => {
  const buttonStyle: React.CSSProperties = {
    color: color,
    background: "transparent",
    // @ts-ignore: CSS variable for SCSS
    "--c": bgborder,
  };

  const handleNavLinkClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    if (onClick) onClick(e);
    if (scrollToTop) handleNavLinkClick();
  };

  return (
    <div className={`Button ${layout}`}>
      {to ? (
        <Link className="Button-link" to={to} onClick={handleClick}>
          <div className="Button-txt Button-txt-form" style={buttonStyle}>
            {children}
          </div>
        </Link>
      ) : (
        <button className="Button-link" onClick={handleClick} style={buttonStyle}>
          <div className="Button-txt Button-txt-form">{children}</div>
        </button>
      )}
    </div>
  );
};

export default Button;
